package com.arena_web.data.api

import com.arena_web.data.dto.ActivityCountDto
import com.arena_web.data.dto.ActivityDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import io.ktor.client.*

class ActivityApi(private val client: HttpClient) {

    suspend fun getActivity(): ApiResponse<ActivityDto> {
        return client.apiGet("v1/activity")
    }

    suspend fun getActivityCount(): ApiResponse<ActivityCountDto> {
        return client.apiGet("v1/activity/count")
    }
}
